 $(function(){
   $('.ar-item').click(function(){
     $(this).find('.ar-item-content').toggle();
     var text = $(this).find('.ar-item-title span').text();
     if(text == '-'){
       text = '+';
     }else{
       text = '-';
     }
     var text = $(this).find('.ar-item-title span').text(text);
   });
 })